import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import toast from "react-hot-toast";
import HomeService from "../Services/HomeService";
import { useNavigate } from "react-router-dom";
import HttpClientXml from "../utils/HttpClientXml";
import Select from "react-select";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "15px",
  fontWeight: "bold",
};

const ManageCityDetails = () => {
  const [cityDetails, setCityDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editID, setEditID] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [cities, setCities] = useState([]);
  const [localities, setLocalities] = useState([]);
  const [apartments, setApartments] = useState([]);
  const [uploadedImages, setUploadedImages] = useState({});
  const navigate = useNavigate();

  // Initial edit form data structure
  const [editData, setEditData] = useState({
    city: "",
    firstSection: {
      image: "", // New image field added here
      mainTag: "",
      header: "",
      descriptions: [""],
      tags: [{ icon: "", content: "" }],
    },
    mapSection: {
      icon: "",
      heading: "",
      desc: "",
      url: "",
    },
    secondSection: {
      locality: {
        icon: "",
        localities: [],
      },
      appartment: {
        icon: "",
        appartments: [],
      },
      commercial: {
        icon: "",
        items: [""],
      },
    },
    thirdSection: {
      image: "",
      heading: "",
      desc: "",
      points: [{ icon: "", content: "" }],
    },
    fourthSection: {
      heading: "",
      subHeading: "",
      sections: [{ icon: "", header: "", desc: "" }],
    },
    fifthSection: {
      heading: "",
      desc: "",
      sections: [{ icon: "", heading: "", desc: "" }],
    },
    sixthSection: {
      heading: "",
      desc: "",
      sections: [{ icon: "", heading: "", desc: "" }],
    },
    seventhSection: {
      counts: [{ heading: "", subHeading: "" }],
      midHeading: "",
      midSubHeading: "",
      works: [{ icon: "", heading: "", subheading: "" }],
    },
    eighthSection: {
      image: "",
      heading: "",
      description: "",
      appStore: "",
      playStore: "",
    },
    ninethSection: {
      heading: "",
      desc: "",
    },
  });

  // Fetch all cities
  const fetchCities = async () => {
    try {
      const res = await HomeService.getCities();
      if (res?.data) {
        setCities(res.data);
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
      toast.error("Failed to fetch cities");
    }
  };

  // Fetch localities when city changes
  const fetchLocalities = async (cityId) => {
    if (!cityId) return;
    try {
      const res = await HomeService.getLocalities();
      if (res?.data) {
        const filteredLocalities = res.data.filter(
          (item) => item.city && item.city._id === cityId,
        );
        setLocalities(filteredLocalities);
      }
    } catch (error) {
      console.error("Error fetching localities:", error);
      toast.error("Failed to fetch localities");
    }
  };

  // Fetch apartments when city changes
  const fetchApartments = async (cityId) => {
    if (!cityId) return;
    try {
      const res = await HomeService.getApartment();
      if (res?.data) {
        const filteredApartments = res.data.filter(
          (item) => item.city && item.city._id === cityId,
        );
        setApartments(filteredApartments);
      }
    } catch (error) {
      console.error("Error fetching apartments:", error);
      toast.error("Failed to fetch apartments");
    }
  };

  // Prepare options for react-select
  const localityOptions = localities.map((loc) => ({
    value: loc._id,
    label: loc.name,
  }));

  const apartmentOptions = apartments.map((apt) => ({
    value: apt._id,
    label: apt.aptName || apt.name,
  }));

  // Function to show description in popup
  const showDescriptionPopup = (content, title = "Description") => {
    Swal.fire({
      title: title,
      html: `
        <div style="text-align: left; max-height: 400px; overflow-y: auto; padding: 10px;">
          <p style="white-space: pre-wrap; word-wrap: break-word;">${
            content || "No description available"
          }</p>
        </div>
      `,
      showCloseButton: true,
      showConfirmButton: false,
      width: "600px",
      customClass: {
        popup: "description-popup",
      },
    });
  };

  const columns = [
    {
      name: "S.No.",
      selector: (row, index) => index + 1,
      sortable: true,
      //   width: "80px",
    },
    {
      name: "City",
      selector: (row) => row.city?.name || row.cityData?.name || "Unknown City",
      sortable: true,
      cell: (row) => (
        <div className="d-flex align-items-center">
          <span className="badge bg-primary" style={{ fontSize: "12px" }}>
            {row.city?.name || row.cityData?.name || "Unknown City"}
          </span>
        </div>
      ),
      //   width: "150px",
    },
    // {
    //   name: "Main Tag",
    //   selector: (row) => row.firstSection?.mainTag || "",
    //   sortable: true,
    //   cell: (row) => {
    //     const mainTag = row.firstSection?.mainTag || "";
    //     const shortTag =
    //       mainTag.length > 20 ? `${mainTag.substring(0, 20)}...` : mainTag;

    //     return (
    //       <div className="d-flex align-items-center">
    //         <span className="me-2" style={{ minWidth: "50px" }}>
    //           {shortTag || <span className="text-muted">No tag</span>}
    //         </span>
    //         {mainTag.length > 20 && (
    //           <button
    //             type="button"
    //             className="btn btn-sm p-0"
    //             onClick={() => showDescriptionPopup(mainTag, "Main Tag")}
    //             title="View full tag"
    //             style={{
    //               background: "transparent",
    //               border: "none",
    //               color: "#007bff",
    //               fontSize: "16px",
    //             }}
    //           >
    //             <i className="fa-solid fa-eye"></i>
    //           </button>
    //         )}
    //       </div>
    //     );
    //   },
    //   //   width: "200px",
    // },
    // {
    //   name: "Header",
    //   selector: (row) => row.firstSection?.header || "",
    //   sortable: true,
    //   cell: (row) => {
    //     const header = row.firstSection?.header || "";
    //     const shortHeader =
    //       header.length > 25 ? `${header.substring(0, 25)}...` : header;

    //     return (
    //       <div className="d-flex align-items-center">
    //         <span className="me-2" style={{ minWidth: "50px" }}>
    //           {shortHeader || <span className="text-muted">No header</span>}
    //         </span>
    //         {header.length > 25 && (
    //           <button
    //             type="button"
    //             className="btn btn-sm p-0"
    //             onClick={() => showDescriptionPopup(header, "Header")}
    //             title="View full header"
    //             style={{
    //               background: "transparent",
    //               border: "none",
    //               color: "#007bff",
    //               fontSize: "16px",
    //             }}
    //           >
    //             <i className="fa-solid fa-eye"></i>
    //           </button>
    //         )}
    //       </div>
    //     );
    //   },
    //   //   width: "250px",
    // },
    {
      name: "Created Date",
      selector: (row) =>
        new Date(
          row.createdAt || row.createdOn || row.updatedAt,
        ).toLocaleDateString(),
      sortable: true,
      center: true,
      //   width: "120px",
    },
    {
      name: "Action",
      cell: (row) => (
        <div>
          <button
            title="Edit"
            onClick={() => handleEdit(row)}
            className="btn btn-sm me-2"
            style={{
              background: "transparent",
              border: "none",
              color: "rgb(133, 218, 79)",
              fontSize: "20px",
            }}
          >
            <i className="fa-solid fa-pen-to-square fs-5"></i>
          </button>
          {/* <button
            title="Delete"
            onClick={() => handleDelete(row._id)}
            className="btn btn-sm"
            style={{
              background: "transparent",
              border: "none",
              color: "#dc3545",
            }}
          >
            <i className="fa-solid fa-trash-can fs-5"></i>
          </button> */}
        </div>
      ),
      center: true,
      //   width: "120px",
    },
  ];

  // Fetch all city details
  const fetchAllCityDetails = async () => {
    setLoading(true);
    try {
      const res = await HomeService.getCityDetails();
      console.log("City details data:", res.data);
      setCityDetails(res.data);
    } catch (error) {
      console.error("Error fetching city details:", error);
      toast.error("Failed to load city details!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllCityDetails();
    fetchCities();
  }, []);

  const handleEdit = async (row) => {
    setIsEdit(true);
    setEditID(row._id);

    // Fetch localities and apartments for the selected city
    const cityId = row.city?._id || row.city || "";
    if (cityId) {
      await fetchLocalities(cityId);
      await fetchApartments(cityId);
    }

    // Prepare edit data from the row
    const preparedEditData = {
      city: cityId,
      firstSection: row.firstSection || {
        image: "", // New image field
        mainTag: "",
        header: "",
        descriptions: [""],
        tags: [{ icon: "", content: "" }],
      },
      mapSection: row.mapSection || {
        icon: "",
        heading: "",
        desc: "",
        url: "",
      },
      secondSection: row.secondSection || {
        locality: {
          icon: "",
          localities: [],
        },
        appartment: {
          icon: "",
          appartments: [],
        },
        commercial: {
          icon: "",
          items: [""],
        },
      },
      thirdSection: row.thirdSection || {
        image: "",
        heading: "",
        desc: "",
        points: [{ icon: "", content: "" }],
      },
      fourthSection: row.fourthSection || {
        heading: "",
        subHeading: "",
        sections: [{ icon: "", header: "", desc: "" }],
      },
      fifthSection: row.fifthSection || {
        heading: "",
        desc: "",
        sections: [{ icon: "", heading: "", desc: "" }],
      },
      sixthSection: row.sixthSection || {
        heading: "",
        desc: "",
        sections: [{ icon: "", heading: "", desc: "" }],
      },
      seventhSection: row.seventhSection || {
        counts: [{ heading: "", subHeading: "" }],
        midHeading: "",
        midSubHeading: "",
        works: [{ icon: "", heading: "", subheading: "" }],
      },
      eighthSection: row.eighthSection || {
        image: "",
        heading: "",
        description: "",
        appStore: "",
        playStore: "",
      },
      ninethSection: row.ninethSection || {
        heading: "",
        desc: "",
      },
    };

    // Ensure arrays are properly formatted
    if (
      !preparedEditData.firstSection.descriptions ||
      !Array.isArray(preparedEditData.firstSection.descriptions)
    ) {
      preparedEditData.firstSection.descriptions = [""];
    }
    if (
      !preparedEditData.firstSection.tags ||
      !Array.isArray(preparedEditData.firstSection.tags)
    ) {
      preparedEditData.firstSection.tags = [{ icon: "", content: "" }];
    }
    if (
      !preparedEditData.secondSection.commercial.items ||
      !Array.isArray(preparedEditData.secondSection.commercial.items)
    ) {
      preparedEditData.secondSection.commercial.items = [""];
    }
    if (
      !preparedEditData.thirdSection.points ||
      !Array.isArray(preparedEditData.thirdSection.points)
    ) {
      preparedEditData.thirdSection.points = [{ icon: "", content: "" }];
    }
    if (
      !preparedEditData.fourthSection.sections ||
      !Array.isArray(preparedEditData.fourthSection.sections)
    ) {
      preparedEditData.fourthSection.sections = [
        { icon: "", header: "", desc: "" },
      ];
    }
    if (
      !preparedEditData.fifthSection.sections ||
      !Array.isArray(preparedEditData.fifthSection.sections)
    ) {
      preparedEditData.fifthSection.sections = [
        { icon: "", heading: "", desc: "" },
      ];
    }
    if (
      !preparedEditData.sixthSection.sections ||
      !Array.isArray(preparedEditData.sixthSection.sections)
    ) {
      preparedEditData.sixthSection.sections = [
        { icon: "", heading: "", desc: "" },
      ];
    }
    if (
      !preparedEditData.seventhSection.counts ||
      !Array.isArray(preparedEditData.seventhSection.counts)
    ) {
      preparedEditData.seventhSection.counts = [
        { heading: "", subHeading: "" },
      ];
    }
    if (
      !preparedEditData.seventhSection.works ||
      !Array.isArray(preparedEditData.seventhSection.works)
    ) {
      preparedEditData.seventhSection.works = [
        { icon: "", heading: "", subheading: "" },
      ];
    }

    // Store existing images in uploadedImages state for preview
    const imagesToStore = {};

    // First Section Image
    if (preparedEditData.firstSection?.image) {
      imagesToStore["firstSection.image"] = preparedEditData.firstSection.image;
    }

    // Map Section Icon
    if (preparedEditData.mapSection?.icon) {
      imagesToStore["mapSection.icon"] = preparedEditData.mapSection.icon;
    }

    // First Section Tags
    if (preparedEditData.firstSection?.tags) {
      preparedEditData.firstSection.tags.forEach((tag, index) => {
        if (tag?.icon) {
          imagesToStore[`firstSection.tags[${index}].icon`] = tag.icon;
        }
      });
    }

    // Second Section Icons
    if (preparedEditData.secondSection?.locality?.icon) {
      imagesToStore["secondSection.locality.icon"] =
        preparedEditData.secondSection.locality.icon;
    }
    if (preparedEditData.secondSection?.appartment?.icon) {
      imagesToStore["secondSection.appartment.icon"] =
        preparedEditData.secondSection.appartment.icon;
    }
    if (preparedEditData.secondSection?.commercial?.icon) {
      imagesToStore["secondSection.commercial.icon"] =
        preparedEditData.secondSection.commercial.icon;
    }

    // Third Section
    if (preparedEditData.thirdSection?.image) {
      imagesToStore["thirdSection.image"] = preparedEditData.thirdSection.image;
    }
    if (preparedEditData.thirdSection?.points) {
      preparedEditData.thirdSection.points.forEach((point, index) => {
        if (point?.icon) {
          imagesToStore[`thirdSection.points[${index}].icon`] = point.icon;
        }
      });
    }

    // Fourth Section
    if (preparedEditData.fourthSection?.sections) {
      preparedEditData.fourthSection.sections.forEach((section, index) => {
        if (section?.icon) {
          imagesToStore[`fourthSection.sections[${index}].icon`] = section.icon;
        }
      });
    }

    // Fifth Section
    if (preparedEditData.fifthSection?.sections) {
      preparedEditData.fifthSection.sections.forEach((section, index) => {
        if (section?.icon) {
          imagesToStore[`fifthSection.sections[${index}].icon`] = section.icon;
        }
      });
    }

    // Sixth Section
    if (preparedEditData.sixthSection?.sections) {
      preparedEditData.sixthSection.sections.forEach((section, index) => {
        if (section?.icon) {
          imagesToStore[`sixthSection.sections[${index}].icon`] = section.icon;
        }
      });
    }

    // Seventh Section
    if (preparedEditData.seventhSection?.works) {
      preparedEditData.seventhSection.works.forEach((work, index) => {
        if (work?.icon) {
          imagesToStore[`seventhSection.works[${index}].icon`] = work.icon;
        }
      });
    }

    // Eighth Section
    if (preparedEditData.eighthSection?.image) {
      imagesToStore["eighthSection.image"] =
        preparedEditData.eighthSection.image;
    }

    setUploadedImages(imagesToStore);
    setEditData(preparedEditData);
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Delete City Details?",
      text: "Are you sure you want to delete these city details?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#d33",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      try {
        const res = await HomeService.deleteCityDetails(id);
        if (res?.status) {
          Swal.fire("Deleted!", "City details have been deleted.", "success");
          fetchAllCityDetails();
        } else {
          Swal.fire(
            "Error!",
            res?.message || "Failed to delete city details.",
            "error",
          );
        }
      } catch (error) {
        Swal.fire("Error!", "Failed to delete city details.", "error");
      }
    }
  };

  // Helper function to update nested state with array indices
  const updateNestedState = (path, value) => {
    setEditData((prev) => {
      const newData = { ...prev };
      const parts = path.split(".");
      let current = newData;

      for (let i = 0; i < parts.length - 1; i++) {
        const part = parts[i];

        // Check if this part is an array index like "tags[0]"
        const arrayMatch = part.match(/(\w+)\[(\d+)\]/);

        if (arrayMatch) {
          const arrayName = arrayMatch[1];
          const arrayIndex = parseInt(arrayMatch[2]);

          if (!current[arrayName] || !Array.isArray(current[arrayName])) {
            current[arrayName] = [];
          }

          // Ensure the array has enough elements
          while (current[arrayName].length <= arrayIndex) {
            current[arrayName].push({});
          }

          current = current[arrayName][arrayIndex];
        } else {
          if (!current[part]) {
            current[part] = {};
          }
          current = current[part];
        }
      }

      // Set the value
      const lastPart = parts[parts.length - 1];
      current[lastPart] = value;

      return newData;
    });
  };

  // Image upload function
  const handleImageUpload = async (file, path) => {
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      toast.error("Please select a valid image file");
      return null;
    }

    const data = new FormData();
    data.append("image", file);

    try {
      const res = await HttpClientXml.fileUplode("image-upload", "POST", data);
      if (res?.image) {
        // Update form data with the uploaded image URL
        updateNestedState(path, res.image);

        // Store for preview
        setUploadedImages((prev) => ({
          ...prev,
          [path]: res.image,
        }));

        toast.success("Image uploaded successfully!");
        return res.image;
      } else {
        toast.error(res?.message || "Failed to upload image");
        return null;
      }
    } catch (error) {
      toast.error("Failed to upload image.");
      console.error("Error uploading image:", error);
      return null;
    }
  };

  // Remove image function
  const handleRemoveImage = (path) => {
    // Update form data by setting the image to empty string
    updateNestedState(path, "");

    // Remove from uploaded images
    setUploadedImages((prev) => {
      const newImages = { ...prev };
      delete newImages[path];
      return newImages;
    });

    toast.success("Image removed");
  };

  // Handle text input changes in edit form - FIXED VERSION
  const handleEditTextChange = (e, path) => {
    const { value } = e.target;
    updateNestedState(path, value);
  };

  // Handle array item changes in edit form - FIXED VERSION
  const handleEditArrayItemChange = (index, value, arrayPath, field = null) => {
    const path = field
      ? `${arrayPath}[${index}].${field}`
      : `${arrayPath}[${index}]`;
    updateNestedState(path, value);
  };

  // Handle city change in edit form
  const handleEditCityChange = (e) => {
    const cityId = e.target.value;
    updateNestedState("city", cityId);
    if (cityId) {
      fetchLocalities(cityId);
      fetchApartments(cityId);
    }
  };

  // Handle react-select change for localities
  const handleEditLocalitySelectChange = (selectedOptions) => {
    const selectedIds = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    updateNestedState("secondSection.locality.localities", selectedIds);
  };

  // Handle react-select change for apartments
  const handleEditApartmentSelectChange = (selectedOptions) => {
    const selectedIds = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    updateNestedState("secondSection.appartment.appartments", selectedIds);
  };

  // Add new item to array in edit form
  const addEditArrayItem = (arrayPath, defaultValue) => {
    setEditData((prev) => {
      const newData = JSON.parse(JSON.stringify(prev));
      const pathParts = arrayPath.split(".");
      let current = newData;

      for (let i = 0; i < pathParts.length; i++) {
        if (!current[pathParts[i]]) {
          current[pathParts[i]] = [];
        }
        current = current[pathParts[i]];
      }

      current.push(JSON.parse(JSON.stringify(defaultValue)));
      return newData;
    });
  };

  // Remove item from array in edit form
  const removeEditArrayItem = (index, arrayPath) => {
    setEditData((prev) => {
      const newData = JSON.parse(JSON.stringify(prev));
      const pathParts = arrayPath.split(".");
      let current = newData;

      for (let i = 0; i < pathParts.length; i++) {
        current = current[pathParts[i]];
      }

      if (current.length > 1) {
        current.splice(index, 1);
      }

      return newData;
    });
  };

  // Handle edit form submission
  const handleEditSubmit = async (e) => {
    e.preventDefault();

    if (!editData.city) {
      toast.error("Please select a city");
      return;
    }

    setEditLoading(true);
    try {
      console.log("Updating city details:", editData);
      const res = await HomeService.updateCityDetails(editID, editData);

      if (res?.status) {
        toast.success("City details updated successfully!");
        setIsEdit(false);
        setEditID("");
        setUploadedImages({});
        fetchAllCityDetails();
      } else {
        toast.error(res?.message || "Failed to update city details");
      }
    } catch (error) {
      toast.error("Failed to update city details.");
      console.error("Error updating city details:", error);
    } finally {
      setEditLoading(false);
    }
  };

  // Handle cancel edit
  const handleCancelEdit = () => {
    setIsEdit(false);
    setEditID("");
    setUploadedImages({});
    setEditData({
      city: "",
      firstSection: {
        image: "", // New image field
        mainTag: "",
        header: "",
        descriptions: [""],
        tags: [{ icon: "", content: "" }],
      },
      mapSection: {
        icon: "",
        heading: "",
        desc: "",
        url: "",
      },
      secondSection: {
        locality: {
          icon: "",
          localities: [],
        },
        appartment: {
          icon: "",
          appartments: [],
        },
        commercial: {
          icon: "",
          items: [""],
        },
      },
      thirdSection: {
        image: "",
        heading: "",
        desc: "",
        points: [{ icon: "", content: "" }],
      },
      fourthSection: {
        heading: "",
        subHeading: "",
        sections: [{ icon: "", header: "", desc: "" }],
      },
      fifthSection: {
        heading: "",
        desc: "",
        sections: [{ icon: "", heading: "", desc: "" }],
      },
      sixthSection: {
        heading: "",
        desc: "",
        sections: [{ icon: "", heading: "", desc: "" }],
      },
      seventhSection: {
        counts: [{ heading: "", subHeading: "" }],
        midHeading: "",
        midSubHeading: "",
        works: [{ icon: "", heading: "", subheading: "" }],
      },
      eighthSection: {
        image: "",
        heading: "",
        description: "",
        appStore: "",
        playStore: "",
      },
      ninethSection: {
        heading: "",
        desc: "",
      },
    });
  };

  // Function to render image preview with remove option
  const renderImagePreview = (imageUrl, path, altText = "Preview") => {
    if (!imageUrl) return null;

    return (
      <div className="mb-2 position-relative">
        <img
          src={imageUrl}
          alt={altText}
          style={{
            width: "80px",
            height: "80px",
            objectFit: "cover",
            borderRadius: "5px",
            border: "2px solid #dee2e6",
          }}
        />
        <button
          type="button"
          className="btn btn-danger btn-sm position-absolute"
          style={{
            top: "5px",
            right: "5px",
            width: "24px",
            height: "24px",
            padding: "0",
          }}
          onClick={() => handleRemoveImage(path)}
          title="Remove image"
        >
          <i className="fa-solid fa-times" style={{ fontSize: "12px" }}></i>
        </button>
        <div className="small text-success mt-1">
          <i className="fa-solid fa-check me-1"></i>
          Image uploaded
        </div>
      </div>
    );
  };

  // Function to render edit form
  const renderEditForm = () => {
    return (
      <div className="card">
        <div className="card-header">
          <h4 className="mb-0">Edit City Details</h4>
        </div>
        <div className="card-body">
          <form onSubmit={handleEditSubmit}>
            {/* City Selection */}
            {/* <div className="row mb-4">
              <div className="col-md-6">
                <label>
                  Select City<span className="text-danger">*</span>
                </label>
                <select
                  className="form-control"
                  name="city"
                  value={editData.city}
                  onChange={handleEditCityChange}
                  required
                >
                  <option value="" disabled>
                    ---Select City---
                  </option>
                  {cities.map((city) => (
                    <option key={city._id} value={city._id}>
                      {city.name}
                    </option>
                  ))}
                </select>
              </div>
            </div> */}

            {/* First Section */}
            <div className="card mb-4">
              <div className="card-header">
                <h5 className="mb-0">Banner Section</h5>
              </div>
              <div className="card-body">
                {/* Header Image Upload */}
                <div className="row">
                  <div className="col-md-12 mt-3">
                    <label>Header Image</label>
                    <div>
                      {renderImagePreview(
                        uploadedImages["firstSection.image"],
                        "firstSection.image",
                        "Header image",
                      )}
                      <div className="input-group">
                        <input
                          type="file"
                          className="form-control"
                          accept="image/*"
                          onChange={async (e) => {
                            const file = e.target.files[0];
                            if (file) {
                              await handleImageUpload(
                                file,
                                "firstSection.image",
                              );
                            }
                          }}
                        />
                        {/* <button
                          type="button"
                          className="btn btn-outline-info"
                          onClick={() => {
                            document
                              .querySelector(
                                'input[accept="image/*"][onchange*="firstSection.image"]'
                              )
                              ?.click();
                          }}
                        >
                          <i className="fa-solid fa-upload me-1"></i>
                          Upload Image
                        </button> */}
                      </div>
                      {/* <small className="text-muted">
                        Recommended size: 1200x400px, Max size: 2MB
                      </small> */}
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 mt-3">
                    <label>Main Tag</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editData.firstSection?.mainTag || ""}
                      onChange={(e) =>
                        handleEditTextChange(e, "firstSection.mainTag")
                      }
                      placeholder="e.g., Premium Properties"
                    />
                  </div>
                  <div className="col-md-6 mt-3">
                    <label>Header</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editData.firstSection?.header || ""}
                      onChange={(e) =>
                        handleEditTextChange(e, "firstSection.header")
                      }
                      placeholder="e.g., Discover Your Dream Home"
                    />
                  </div>
                </div>

                {/* Descriptions */}
                <div className="mt-3">
                  <label>Descriptions</label>
                  {(editData.firstSection?.descriptions || []).map(
                    (desc, index) => (
                      <div key={index} className="input-group mb-2">
                        <input
                          type="text"
                          className="form-control"
                          value={desc || ""}
                          onChange={(e) =>
                            handleEditArrayItemChange(
                              index,
                              e.target.value,
                              "firstSection.descriptions",
                            )
                          }
                          placeholder={`Description ${index + 1}`}
                        />
                        {(editData.firstSection?.descriptions || []).length >
                          1 && (
                          <button
                            type="button"
                            className="btn btn-outline-danger"
                            onClick={() =>
                              removeEditArrayItem(
                                index,
                                "firstSection.descriptions",
                              )
                            }
                          >
                            <i className="fa-solid fa-trash"></i>
                          </button>
                        )}
                      </div>
                    ),
                  )}
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={() =>
                      addEditArrayItem("firstSection.descriptions", "")
                    }
                  >
                    <i className="fa-solid fa-plus me-1"></i> Add Description
                  </button>
                </div>

                {/* Tags */}
                <div className="mt-3">
                  <label>Tags</label>
                  {(editData.firstSection?.tags || []).map((tag, index) => (
                    <div key={index} className="border p-3 mb-3 rounded">
                      <div className="row">
                        <div className="col-md-6">
                          <label>Icon Image</label>
                          <div className="mb-2">
                            {renderImagePreview(
                              uploadedImages[
                                `firstSection.tags[${index}].icon`
                              ],
                              `firstSection.tags[${index}].icon`,
                              "Tag icon",
                            )}
                            <input
                              type="file"
                              className="form-control"
                              accept="image/*"
                              onChange={async (e) => {
                                const file = e.target.files[0];
                                if (file) {
                                  await handleImageUpload(
                                    file,
                                    `firstSection.tags[${index}].icon`,
                                  );
                                }
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-5">
                          <label>Content</label>
                          <input
                            type="text"
                            className="form-control"
                            value={tag?.content || ""}
                            onChange={(e) =>
                              handleEditArrayItemChange(
                                index,
                                e.target.value,
                                "firstSection.tags",
                                "content",
                              )
                            }
                            placeholder="Tag content"
                          />
                        </div>
                        <div className="col-md-1 d-flex align-items-end">
                          {(editData.firstSection?.tags || []).length > 1 && (
                            <button
                              type="button"
                              className="btn btn-outline-danger"
                              onClick={() =>
                                removeEditArrayItem(index, "firstSection.tags")
                              }
                            >
                              <i className="fa-solid fa-trash"></i>
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={() =>
                      addEditArrayItem("firstSection.tags", {
                        icon: "",
                        content: "",
                      })
                    }
                  >
                    <i className="fa-solid fa-plus me-1"></i> Add Tag
                  </button>
                </div>
              </div>
            </div>

            {/* Map Section */}
            {/* <div className="card mb-4">
              <div className="card-header">
                <h5 className="mb-0">Map Section</h5>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6 mt-3">
                    <label>Icon</label>
                    <div>
                      {renderImagePreview(
                        uploadedImages["mapSection.icon"],
                        "mapSection.icon",
                        "Map icon"
                      )}
                      <input
                        type="file"
                        className="form-control"
                        accept="image/*"
                        onChange={async (e) => {
                          const file = e.target.files[0];
                          if (file) {
                            await handleImageUpload(file, "mapSection.icon");
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 mt-3">
                    <label>Heading</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editData.mapSection?.heading || ""}
                      onChange={(e) =>
                        handleEditTextChange(e, "mapSection.heading")
                      }
                      placeholder="Map section heading"
                    />
                  </div>
                  <div className="col-md-6 mt-3">
                    <label>Description</label>
                    <textarea
                      className="form-control"
                      value={editData.mapSection?.desc || ""}
                      onChange={(e) =>
                        handleEditTextChange(e, "mapSection.desc")
                      }
                      placeholder="Map section description"
                      rows="2"
                    />
                  </div>
                  <div className="col-md-6 mt-3">
                    <label>Map URL</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editData.mapSection?.url || ""}
                      onChange={(e) =>
                        handleEditTextChange(e, "mapSection.url")
                      }
                      placeholder="Google Maps URL"
                    />
                  </div>
                </div>
              </div>
            </div> */}

            {/* Second Section */}
            {/* <div className="card mb-4">
              <div className="card-header">
                <h5 className="mb-0">Second Section - Property Types</h5>
              </div>
              <div className="card-body">
                
                <div className="border p-3 mb-3 rounded">
                  <h6>Locality Section</h6>
                  <div className="row">
                    <div className="col-md-6 mt-3">
                      <label>Icon</label>
                      <div>
                        {renderImagePreview(
                          uploadedImages["secondSection.locality.icon"],
                          "secondSection.locality.icon",
                          "Locality icon",
                        )}
                        <input
                          type="file"
                          className="form-control"
                          accept="image/*"
                          onChange={async (e) => {
                            const file = e.target.files[0];
                            if (file) {
                              await handleImageUpload(
                                file,
                                "secondSection.locality.icon",
                              );
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 mt-3">
                      <label>Select Localities</label>
                      <Select
                        isMulti
                        options={localityOptions}
                        value={localityOptions.filter((option) =>
                          (
                            editData.secondSection?.locality?.localities || []
                          ).includes(option.value),
                        )}
                        onChange={handleEditLocalitySelectChange}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        isDisabled={!editData.city}
                        placeholder="Select localities..."
                      />
                    </div>
                  </div>
                </div>

                
                <div className="border p-3 mb-3 rounded">
                  <h6>Apartment Section</h6>
                  <div className="row">
                    <div className="col-md-6 mt-3">
                      <label>Icon</label>
                      <div>
                        {renderImagePreview(
                          uploadedImages["secondSection.appartment.icon"],
                          "secondSection.appartment.icon",
                          "Apartment icon",
                        )}
                        <input
                          type="file"
                          className="form-control"
                          accept="image/*"
                          onChange={async (e) => {
                            const file = e.target.files[0];
                            if (file) {
                              await handleImageUpload(
                                file,
                                "secondSection.appartment.icon",
                              );
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 mt-3">
                      <label>Select Apartments</label>
                      <Select
                        isMulti
                        options={apartmentOptions}
                        value={apartmentOptions.filter((option) =>
                          (
                            editData.secondSection?.appartment?.appartments ||
                            []
                          ).includes(option.value),
                        )}
                        onChange={handleEditApartmentSelectChange}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        isDisabled={!editData.city}
                        placeholder="Select apartments..."
                      />
                    </div>
                  </div>
                </div>

                
                <div className="border p-3 mb-3 rounded">
                  <h6>Commercial Section</h6>
                  <div className="row">
                    <div className="col-md-6 mt-3">
                      <label>Icon</label>
                      <div>
                        {renderImagePreview(
                          uploadedImages["secondSection.commercial.icon"],
                          "secondSection.commercial.icon",
                          "Commercial icon",
                        )}
                        <input
                          type="file"
                          className="form-control"
                          accept="image/*"
                          onChange={async (e) => {
                            const file = e.target.files[0];
                            if (file) {
                              await handleImageUpload(
                                file,
                                "secondSection.commercial.icon",
                              );
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 mt-3">
                      <label>Commercial Items</label>
                      {(editData.secondSection?.commercial?.items || []).map(
                        (item, index) => (
                          <div key={index} className="input-group mb-2">
                            <input
                              type="text"
                              className="form-control"
                              value={item || ""}
                              onChange={(e) =>
                                handleEditArrayItemChange(
                                  index,
                                  e.target.value,
                                  "secondSection.commercial.items",
                                )
                              }
                              placeholder={`Commercial item ${index + 1}`}
                            />
                            {(editData.secondSection?.commercial?.items || [])
                              .length > 1 && (
                              <button
                                type="button"
                                className="btn btn-outline-danger"
                                onClick={() =>
                                  removeEditArrayItem(
                                    index,
                                    "secondSection.commercial.items",
                                  )
                                }
                              >
                                <i className="fa-solid fa-trash"></i>
                              </button>
                            )}
                          </div>
                        ),
                      )}
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-primary"
                        onClick={() =>
                          addEditArrayItem("secondSection.commercial.items", "")
                        }
                      >
                        <i className="fa-solid fa-plus me-1"></i> Add Commercial
                        Item
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}

            <div className="card mb-4">
              <div className="card-header">
                <h5 className="mb-0"> Our Services Section</h5>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6 mt-3">
                    <label>Heading</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editData.fourthSection?.heading || ""}
                      onChange={(e) =>
                        handleEditTextChange(e, "fourthSection.heading")
                      }
                      placeholder="Services heading"
                    />
                  </div>
                  <div className="col-md-6 mt-3">
                    <label>Sub Heading</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editData.fourthSection?.subHeading || ""}
                      onChange={(e) =>
                        handleEditTextChange(e, "fourthSection.subHeading")
                      }
                      placeholder="Services sub heading"
                    />
                  </div>
                </div>

                {/* Service Sections */}
                <div className="mt-3">
                  <label>Service Items</label>
                  {(editData.fourthSection?.sections || []).map(
                    (section, index) => (
                      <div key={index} className="border p-3 mb-3 rounded">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <h6 className="mb-0">Service {index + 1}</h6>
                          {(editData.fourthSection?.sections || []).length >
                            1 && (
                            <button
                              type="button"
                              className="btn btn-outline-danger btn-sm"
                              onClick={() =>
                                removeEditArrayItem(
                                  index,
                                  "fourthSection.sections",
                                )
                              }
                            >
                              <i className="fa-solid fa-trash"></i>
                            </button>
                          )}
                        </div>
                        <div className="row">
                          <div className="col-md-4">
                            <label>Icon</label>
                            <div>
                              {renderImagePreview(
                                uploadedImages[
                                  `fourthSection.sections[${index}].icon`
                                ],
                                `fourthSection.sections[${index}].icon`,
                                "Service icon",
                              )}
                              <input
                                type="file"
                                className="form-control"
                                accept="image/*"
                                onChange={async (e) => {
                                  const file = e.target.files[0];
                                  if (file) {
                                    await handleImageUpload(
                                      file,
                                      `fourthSection.sections[${index}].icon`,
                                    );
                                  }
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <label>Header</label>
                            <input
                              type="text"
                              className="form-control"
                              value={section?.header || ""}
                              onChange={(e) =>
                                handleEditArrayItemChange(
                                  index,
                                  e.target.value,
                                  "fourthSection.sections",
                                  "header",
                                )
                              }
                              placeholder="Service header"
                            />
                          </div>
                          <div className="col-md-4">
                            <label>Description</label>
                            <textarea
                              className="form-control"
                              value={section?.desc || ""}
                              onChange={(e) =>
                                handleEditArrayItemChange(
                                  index,
                                  e.target.value,
                                  "fourthSection.sections",
                                  "desc",
                                )
                              }
                              placeholder="Service description"
                              rows="2"
                            />
                          </div>
                        </div>
                      </div>
                    ),
                  )}
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={() =>
                      addEditArrayItem("fourthSection.sections", {
                        icon: "",
                        header: "",
                        desc: "",
                      })
                    }
                  >
                    <i className="fa-solid fa-plus me-1"></i> Add Service Item
                  </button>
                </div>
              </div>
            </div>

            <div className="card mb-4">
              <div className="card-header">
                <h5 className="mb-0">Property Types Section</h5>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6 mt-3">
                    <label>Heading</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editData.fifthSection?.heading || ""}
                      onChange={(e) =>
                        handleEditTextChange(e, "fifthSection.heading")
                      }
                      placeholder="Property types heading"
                    />
                  </div>
                  <div className="col-md-6 mt-3">
                    <label>Description</label>
                    <textarea
                      className="form-control"
                      value={editData.fifthSection?.desc || ""}
                      onChange={(e) =>
                        handleEditTextChange(e, "fifthSection.desc")
                      }
                      placeholder="Property types description"
                      rows="2"
                    />
                  </div>
                </div>

                {/* Property Type Sections */}
                <div className="mt-3">
                  <label>Property Type Items</label>
                  {(editData.fifthSection?.sections || []).map(
                    (section, index) => (
                      <div key={index} className="border p-3 mb-3 rounded">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <h6 className="mb-0">Property Type {index + 1}</h6>
                          {(editData.fifthSection?.sections || []).length >
                            1 && (
                            <button
                              type="button"
                              className="btn btn-outline-danger btn-sm"
                              onClick={() =>
                                removeEditArrayItem(
                                  index,
                                  "fifthSection.sections",
                                )
                              }
                            >
                              <i className="fa-solid fa-trash"></i>
                            </button>
                          )}
                        </div>
                        <div className="row">
                          <div className="col-md-4">
                            <label>Icon</label>
                            <div>
                              {renderImagePreview(
                                uploadedImages[
                                  `fifthSection.sections[${index}].icon`
                                ],
                                `fifthSection.sections[${index}].icon`,
                                "Property type icon",
                              )}
                              <input
                                type="file"
                                className="form-control"
                                accept="image/*"
                                onChange={async (e) => {
                                  const file = e.target.files[0];
                                  if (file) {
                                    await handleImageUpload(
                                      file,
                                      `fifthSection.sections[${index}].icon`,
                                    );
                                  }
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <label>Heading</label>
                            <input
                              type="text"
                              className="form-control"
                              value={section?.heading || ""}
                              onChange={(e) =>
                                handleEditArrayItemChange(
                                  index,
                                  e.target.value,
                                  "fifthSection.sections",
                                  "heading",
                                )
                              }
                              placeholder="Property type heading"
                            />
                          </div>
                          <div className="col-md-4">
                            <label>Description</label>
                            <textarea
                              className="form-control"
                              value={section?.desc || ""}
                              onChange={(e) =>
                                handleEditArrayItemChange(
                                  index,
                                  e.target.value,
                                  "fifthSection.sections",
                                  "desc",
                                )
                              }
                              placeholder="Property type description"
                              rows="2"
                            />
                          </div>
                        </div>
                      </div>
                    ),
                  )}
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={() =>
                      addEditArrayItem("fifthSection.sections", {
                        icon: "",
                        heading: "",
                        desc: "",
                      })
                    }
                  >
                    <i className="fa-solid fa-plus me-1"></i> Add Property Type
                  </button>
                </div>
              </div>
            </div>

            <div className="card mb-4">
              <div className="card-header">
                <h5 className="mb-0">Statistics & How It Works Section</h5>
              </div>
              <div className="card-body">
                {/* Counts */}
                <div className="border p-3 mb-3 rounded">
                  <h6>Statistics Counts</h6>
                  {(editData.seventhSection?.counts || []).map(
                    (count, index) => (
                      <div key={index} className="border-bottom pb-2 mb-2">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <h6 className="mb-0">Count {index + 1}</h6>
                          {(editData.seventhSection?.counts || []).length >
                            1 && (
                            <button
                              type="button"
                              className="btn btn-outline-danger btn-sm"
                              onClick={() =>
                                removeEditArrayItem(
                                  index,
                                  "seventhSection.counts",
                                )
                              }
                            >
                              <i className="fa-solid fa-trash"></i>
                            </button>
                          )}
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <label>Heading (Number)</label>
                            <input
                              type="text"
                              className="form-control"
                              value={count?.heading || ""}
                              onChange={(e) =>
                                handleEditArrayItemChange(
                                  index,
                                  e.target.value,
                                  "seventhSection.counts",
                                  "heading",
                                )
                              }
                              placeholder="e.g., 10000+"
                            />
                          </div>
                          <div className="col-md-6">
                            <label>Sub Heading</label>
                            <input
                              type="text"
                              className="form-control"
                              value={count?.subHeading || ""}
                              onChange={(e) =>
                                handleEditArrayItemChange(
                                  index,
                                  e.target.value,
                                  "seventhSection.counts",
                                  "subHeading",
                                )
                              }
                              placeholder="e.g., Properties"
                            />
                          </div>
                        </div>
                      </div>
                    ),
                  )}
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary mt-2"
                    onClick={() =>
                      addEditArrayItem("seventhSection.counts", {
                        heading: "",
                        subHeading: "",
                      })
                    }
                  >
                    <i className="fa-solid fa-plus me-1"></i> Add Statistic
                    Count
                  </button>
                </div>

                {/* How It Works Heading */}
                <div className="row mt-3">
                  <div className="col-md-6">
                    <label>How It Works Heading</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editData.seventhSection?.midHeading || ""}
                      onChange={(e) =>
                        handleEditTextChange(e, "seventhSection.midHeading")
                      }
                      placeholder="How it works heading"
                    />
                  </div>
                  <div className="col-md-6">
                    <label>How It Works Sub Heading</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editData.seventhSection?.midSubHeading || ""}
                      onChange={(e) =>
                        handleEditTextChange(e, "seventhSection.midSubHeading")
                      }
                      placeholder="How it works sub heading"
                    />
                  </div>
                </div>

                {/* Works Steps */}
                <div className="mt-3">
                  <label>How It Works Steps</label>
                  {(editData.seventhSection?.works || []).map((work, index) => (
                    <div key={index} className="border p-3 mb-3 rounded">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6 className="mb-0">Step {index + 1}</h6>
                        {(editData.seventhSection?.works || []).length > 1 && (
                          <button
                            type="button"
                            className="btn btn-outline-danger btn-sm"
                            onClick={() =>
                              removeEditArrayItem(index, "seventhSection.works")
                            }
                          >
                            <i className="fa-solid fa-trash"></i>
                          </button>
                        )}
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <label>Icon</label>
                          <div>
                            {renderImagePreview(
                              uploadedImages[
                                `seventhSection.works[${index}].icon`
                              ],
                              `seventhSection.works[${index}].icon`,
                              "Step icon",
                            )}
                            <input
                              type="file"
                              className="form-control"
                              accept="image/*"
                              onChange={async (e) => {
                                const file = e.target.files[0];
                                if (file) {
                                  await handleImageUpload(
                                    file,
                                    `seventhSection.works[${index}].icon`,
                                  );
                                }
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <label>Heading</label>
                          <input
                            type="text"
                            className="form-control"
                            value={work?.heading || ""}
                            onChange={(e) =>
                              handleEditArrayItemChange(
                                index,
                                e.target.value,
                                "seventhSection.works",
                                "heading",
                              )
                            }
                            placeholder="Step heading"
                          />
                        </div>
                        <div className="col-md-4">
                          <label>Subheading</label>
                          <input
                            type="text"
                            className="form-control"
                            value={work?.subheading || ""}
                            onChange={(e) =>
                              handleEditArrayItemChange(
                                index,
                                e.target.value,
                                "seventhSection.works",
                                "subheading",
                              )
                            }
                            placeholder="Step subheading"
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={() =>
                      addEditArrayItem("seventhSection.works", {
                        icon: "",
                        heading: "",
                        subheading: "",
                      })
                    }
                  >
                    <i className="fa-solid fa-plus me-1"></i> Add Step
                  </button>
                </div>
              </div>
            </div>

            {/* Third Section */}
            <div className="card mb-4">
              <div className="card-header">
                <h5 className="mb-0">About Section</h5>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6 mt-3">
                    <label>Image</label>
                    <div>
                      {renderImagePreview(
                        uploadedImages["thirdSection.image"],
                        "thirdSection.image",
                        "About image",
                      )}
                      <input
                        type="file"
                        className="form-control"
                        accept="image/*"
                        onChange={async (e) => {
                          const file = e.target.files[0];
                          if (file) {
                            await handleImageUpload(file, "thirdSection.image");
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 mt-3">
                    <label>Heading</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editData.thirdSection?.heading || ""}
                      onChange={(e) =>
                        handleEditTextChange(e, "thirdSection.heading")
                      }
                      placeholder="About heading"
                    />
                  </div>
                  <div className="col-12 mt-3">
                    <label>Description</label>
                    <textarea
                      className="form-control"
                      value={editData.thirdSection?.desc || ""}
                      onChange={(e) =>
                        handleEditTextChange(e, "thirdSection.desc")
                      }
                      placeholder="About description"
                      rows="3"
                    />
                  </div>
                </div>

                {/* Points */}
                <div className="mt-3">
                  <label>Key Points</label>
                  {(editData.thirdSection?.points || []).map((point, index) => (
                    <div key={index} className="border p-3 mb-3 rounded">
                      <div className="row">
                        <div className="col-md-6">
                          <label>Icon</label>
                          <div>
                            {renderImagePreview(
                              uploadedImages[
                                `thirdSection.points[${index}].icon`
                              ],
                              `thirdSection.points[${index}].icon`,
                              "Point icon",
                            )}
                            <input
                              type="file"
                              className="form-control"
                              accept="image/*"
                              onChange={async (e) => {
                                const file = e.target.files[0];
                                if (file) {
                                  await handleImageUpload(
                                    file,
                                    `thirdSection.points[${index}].icon`,
                                  );
                                }
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-5">
                          <label>Content</label>
                          <input
                            type="text"
                            className="form-control"
                            value={point?.content || ""}
                            onChange={(e) =>
                              handleEditArrayItemChange(
                                index,
                                e.target.value,
                                "thirdSection.points",
                                "content",
                              )
                            }
                            placeholder="Point content"
                          />
                        </div>
                        <div className="col-md-1 d-flex align-items-end">
                          {(editData.thirdSection?.points || []).length > 1 && (
                            <button
                              type="button"
                              className="btn btn-outline-danger"
                              onClick={() =>
                                removeEditArrayItem(
                                  index,
                                  "thirdSection.points",
                                )
                              }
                            >
                              <i className="fa-solid fa-trash"></i>
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={() =>
                      addEditArrayItem("thirdSection.points", {
                        icon: "",
                        content: "",
                      })
                    }
                  >
                    <i className="fa-solid fa-plus me-1"></i> Add Point
                  </button>
                </div>
              </div>
            </div>

            {/* Sixth Section - Featured Localities */}
            {/* <div className="card mb-4">
              <div className="card-header">
                <h5 className="mb-0">Sixth Section - Featured Localities</h5>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6 mt-3">
                    <label>Heading</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editData.sixthSection?.heading || ""}
                      onChange={(e) =>
                        handleEditTextChange(e, "sixthSection.heading")
                      }
                      placeholder="Featured localities heading"
                    />
                  </div>
                  <div className="col-md-6 mt-3">
                    <label>Description</label>
                    <textarea
                      className="form-control"
                      value={editData.sixthSection?.desc || ""}
                      onChange={(e) =>
                        handleEditTextChange(e, "sixthSection.desc")
                      }
                      placeholder="Featured localities description"
                      rows="2"
                    />
                  </div>
                </div>

                
                <div className="mt-3">
                  <label>Featured Locality Items</label>
                  {(editData.sixthSection?.sections || []).map(
                    (section, index) => (
                      <div key={index} className="border p-3 mb-3 rounded">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <h6 className="mb-0">
                            Featured Locality {index + 1}
                          </h6>
                          {(editData.sixthSection?.sections || []).length >
                            1 && (
                            <button
                              type="button"
                              className="btn btn-outline-danger btn-sm"
                              onClick={() =>
                                removeEditArrayItem(
                                  index,
                                  "sixthSection.sections",
                                )
                              }
                            >
                              <i className="fa-solid fa-trash"></i>
                            </button>
                          )}
                        </div>
                        <div className="row">
                          <div className="col-md-4">
                            <label>Icon</label>
                            <div>
                              {renderImagePreview(
                                uploadedImages[
                                  `sixthSection.sections[${index}].icon`
                                ],
                                `sixthSection.sections[${index}].icon`,
                                "Locality icon",
                              )}
                              <input
                                type="file"
                                className="form-control"
                                accept="image/*"
                                onChange={async (e) => {
                                  const file = e.target.files[0];
                                  if (file) {
                                    await handleImageUpload(
                                      file,
                                      `sixthSection.sections[${index}].icon`,
                                    );
                                  }
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <label>Heading</label>
                            <input
                              type="text"
                              className="form-control"
                              value={section?.heading || ""}
                              onChange={(e) =>
                                handleEditArrayItemChange(
                                  index,
                                  e.target.value,
                                  "sixthSection.sections",
                                  "heading",
                                )
                              }
                              placeholder="Locality name"
                            />
                          </div>
                          <div className="col-md-4">
                            <label>Description</label>
                            <textarea
                              className="form-control"
                              value={section?.desc || ""}
                              onChange={(e) =>
                                handleEditArrayItemChange(
                                  index,
                                  e.target.value,
                                  "sixthSection.sections",
                                  "desc",
                                )
                              }
                              placeholder="Locality description"
                              rows="2"
                            />
                          </div>
                        </div>
                      </div>
                    ),
                  )}
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={() =>
                      addEditArrayItem("sixthSection.sections", {
                        icon: "",
                        heading: "",
                        desc: "",
                      })
                    }
                  >
                    <i className="fa-solid fa-plus me-1"></i> Add Featured
                    Locality
                  </button>
                </div>
              </div>
            </div> */}

            {/* Seventh Section - Statistics & How It Works */}

            {/* Eighth Section - App Download */}
            <div className="card mb-4">
              <div className="card-header">
                <h5 className="mb-0">App Download Section</h5>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6 mt-3">
                    <label>Image</label>
                    <div>
                      {renderImagePreview(
                        uploadedImages["eighthSection.image"],
                        "eighthSection.image",
                        "App preview",
                      )}
                      <input
                        type="file"
                        className="form-control"
                        accept="image/*"
                        onChange={async (e) => {
                          const file = e.target.files[0];
                          if (file) {
                            await handleImageUpload(
                              file,
                              "eighthSection.image",
                            );
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 mt-3">
                    <label>Heading</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editData.eighthSection?.heading || ""}
                      onChange={(e) =>
                        handleEditTextChange(e, "eighthSection.heading")
                      }
                      placeholder="App download heading"
                    />
                  </div>
                  <div className="col-12 mt-3">
                    <label>Description</label>
                    <textarea
                      className="form-control"
                      value={editData.eighthSection?.description || ""}
                      onChange={(e) =>
                        handleEditTextChange(e, "eighthSection.description")
                      }
                      placeholder="App download description"
                      rows="2"
                    />
                  </div>
                  <div className="col-md-6 mt-3">
                    <label>App Store URL</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editData.eighthSection?.appStore || ""}
                      onChange={(e) =>
                        handleEditTextChange(e, "eighthSection.appStore")
                      }
                      placeholder="iOS App Store URL"
                    />
                  </div>
                  <div className="col-md-6 mt-3">
                    <label>Play Store URL</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editData.eighthSection?.playStore || ""}
                      onChange={(e) =>
                        handleEditTextChange(e, "eighthSection.playStore")
                      }
                      placeholder="Google Play Store URL"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Ninth Section - Contact */}
            <div className="card mb-4">
              <div className="card-header">
                <h5 className="mb-0">Contact Section</h5>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6 mt-3">
                    <label>Heading</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editData.ninethSection?.heading || ""}
                      onChange={(e) =>
                        handleEditTextChange(e, "ninethSection.heading")
                      }
                      placeholder="Contact section heading"
                    />
                  </div>
                  <div className="col-md-6 mt-3">
                    <label>Description</label>
                    <textarea
                      className="form-control"
                      value={editData.ninethSection?.desc || ""}
                      onChange={(e) =>
                        handleEditTextChange(e, "ninethSection.desc")
                      }
                      placeholder="Contact section description"
                      rows="2"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Submit Buttons */}
            <div className="mt-4 pt-3 border-top">
              <button
                type="submit"
                className="btn btn-primary me-3"
                style={{
                  background: "rgb(133, 218, 79)",
                  border: "none",
                  padding: "10px 25px",
                  fontWeight: "500",
                }}
                disabled={editLoading}
              >
                {editLoading ? (
                  <>
                    <i className="fa-solid fa-spinner fa-spin me-2"></i>
                    Updating...
                  </>
                ) : (
                  <>
                    <i className="fa-solid fa-floppy-disk me-2"></i>
                    Save Changes
                  </>
                )}
              </button>
              <button
                type="button"
                onClick={handleCancelEdit}
                className="btn btn-secondary"
                style={{
                  padding: "10px 25px",
                  fontWeight: "500",
                }}
              >
                <i className="fa-solid fa-times me-2"></i>
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="main_wrap" style={{ marginTop: "6rem" }}>
        <div className="container-fluid">
          {isEdit ? (
            <section className="chartBox_area">{renderEditForm()}</section>
          ) : (
            <>
              <div className="mt-5">
                <div style={headLineStyle} className="page-headline">
                  Manage City Details
                </div>

                {/* Add New Button */}
                {/* <div className="mb-4 text-end">
                  <button
                    className="btn"
                    style={{
                      background: "rgb(133, 218, 79)",
                      borderRadius: "13px",
                      padding: "10px 30px",
                      fontSize: "16px",
                      fontWeight: "500",
                    }}
                    onClick={() => navigate("/add-city-details")}
                  >
                    <i className="fa-solid fa-plus me-2"></i>
                    Add New City Details
                  </button>
                </div> */}

                {loading ? (
                  <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-2">Loading city details...</p>
                  </div>
                ) : cityDetails.length > 0 ? (
                  <div className="card">
                    <div className="card-body">
                      {/* <div className="mb-3">
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <span className="badge bg-info">
                              Total City Details: {cityDetails.length}
                            </span>
                          </div>
                          <div>
                            <span className="text-muted">
                              Showing {cityDetails.length} city details
                            </span>
                          </div>
                        </div>
                      </div> */}
                      <DataTable
                        columns={columns}
                        data={cityDetails}
                        pagination
                        responsive
                        highlightOnHover
                        striped
                        paginationPerPage={10}
                        paginationRowsPerPageOptions={[10, 20, 30, 50]}
                        noDataComponent={
                          <div className="text-center py-4">
                            <i className="fa-solid fa-city fa-2x text-muted mb-3"></i>
                            <p>No city details found</p>
                          </div>
                        }
                      />
                    </div>
                  </div>
                ) : (
                  <div className="card">
                    <div className="card-body text-center py-5">
                      <i className="fa-solid fa-city fa-3x text-muted mb-3"></i>
                      <h5>No City Details Available</h5>
                      <p className="text-muted">
                        There are no city details to display at the moment.
                      </p>
                      <button
                        className="btn mt-3"
                        style={{
                          background: "rgb(133, 218, 79)",
                          borderRadius: "13px",
                          padding: "10px 30px",
                          fontSize: "16px",
                          fontWeight: "500",
                        }}
                        onClick={() => navigate("/add-city-details")}
                      >
                        <i className="fa-solid fa-plus me-2"></i>
                        Add New City Details
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>

      {/* CSS for the popup and react-select */}
      <style>
        {`
          .description-popup .swal2-popup {
            max-width: 600px;
          }
          .description-popup .swal2-html-container {
            overflow: hidden;
          }
          .basic-multi-select .select__control {
            border: 1px solid #ced4da;
            min-height: 38px;
          }
          .basic-multi-select .select__control--is-focused {
            border-color: #80bdff;
            box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
          }
        `}
      </style>
    </>
  );
};

export default ManageCityDetails;
